import * as React from "react";
import type { SVGProps } from "react";
const SvgMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m1 6-.496-.868A1 1 0 0 0 0 6zm0 16H0a1 1 0 0 0 1.496.868zm15 0-.447.894a1 1 0 0 0 .943-.026zm7-4 .496.868A1 1 0 0 0 24 18zm0-16h1a1 1 0 0 0-1.496-.868zM8 2l.447-.894a1 1 0 0 0-.943.026zM0 6v16h2V6zm1.496 16.868 7-4-.992-1.736-7 4zm6.057-3.974 8 4 .894-1.788-8-4zm8.943 3.974 7-4-.992-1.736-7 4zM24 18V2h-2v16zM22.504 1.132l-7 4 .992 1.736 7-4zm-6.057 3.974-8-4-.894 1.788 8 4zM7.504 1.132l-7 4 .992 1.736 7-4zM7 2v16h2V2zm8 4v16h2V6z"
    />
  </svg>
);
export default SvgMap;
